import { createFileRoute } from "@tanstack/react-router";
import { EarnPage } from "../../features/rewards/pages/earn-page";
import { assetRouteLoader } from "../../features/rewards/utils/route-loaders";

export const Route = createFileRoute("/_layout/rewards/$asset")({
  loader: assetRouteLoader,
  component: EarnPage,
});
